import React, { useEffect, useState } from 'react';

import Login from './Login';
import LandingPage from './LandingPage';
import { setLogguedUserData } from '../../reducers/commonSlice';
import { useDispatch, useSelector } from 'react-redux';

function StaticPage(props) {

    const [currentOption, setCurrentOption] = useState('main');

    const logguedUserData = useSelector(state => state.common.logguedUserData);

    const dispatch = useDispatch();

    useEffect(() => {
        const a = setTimeout(() => {
            if (!logguedUserData) {
                const loggued_user = localStorage.getItem("loggued_user");
                if (loggued_user)
                    dispatch(setLogguedUserData(JSON.parse(loggued_user)));
            }
        }, 250);

    }, []);

    return (
        <>
            {
                currentOption === 'main' && <LandingPage setCurrentOption={setCurrentOption} />
            }

            {
                currentOption === 'login' && <Login setCurrentOption={setCurrentOption} />
            }
        </>

    );
}

export default StaticPage;